import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import Select from 'admin/components/atoms/Select';
import { fetchOrganizations } from 'admin/actions/organization';
import { AppContext } from 'admin/components/App';

// context
// privateMoney selected by superuser -> options should be selfOrg + memberOrg
// privateMoney selected by issuer -> options should be selfOrg + memberOrg
// privateMoney selected by member -> options should only be selfOrg
const OrganizationSelector = ({ privateMoney = {}, onChangeOrganization, disabled, ...rest }) => {
  const ctx = useContext(AppContext);
  const [ops, setOps] = useState();
  const [selectedOp, setSelectedOp] = useState();

  useEffect(() => {
    if (privateMoney.id) {
      const query = `private_money_id=${privateMoney.id}&per_page=10000`;
      fetchOrganizations(query)
        .then((members) => {
          const issuer = privateMoney.organization;
          const ops = members.rows.map((o) => ({ label: o.name, value: o }));
          ops.push({ label: issuer.name, value: issuer });
          setOps(ops);
          setSelectedOp(null);
        })
        .catch((err) => {
          // xxx: if the login AdminUser is a member of the money this endpoint will fail
          const { organization } = ctx.user;
          const ops = [{ label: organization.name, value: organization }];
          setOps(ops);
          setSelectedOp(null);
        });
    }
  }, [privateMoney]);

  const handleOrganizationSelect = (op) => {
    setSelectedOp(op);
    onChangeOrganization(op.value);
  };

  return (
    <>
      <Select
        options={ops}
        onChange={handleOrganizationSelect}
        placeholder="「組織」を選択"
        value={selectedOp}
        isDisabled={disabled}
        {...rest}
      />
    </>
  );
};

export default styled(OrganizationSelector)``;
